import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import withMobileDialog from "@material-ui/core/withMobileDialog";

import {EmptyRecord} from "../../utils/PageUtility";
import RecordPagination  from "../../utils/RecordsPagination";
import Edit from "@material-ui/icons/Edit";
import Approve from "@material-ui/icons/DoneOutline";
import Decline from "@material-ui/icons/Close";
import moment from "moment";


import {
    Table,
    TableHead,
    TableCell,
    TableRow,
    TableBody,
} from "@material-ui/core";
import {appHelpers} from "../../_helpers";
//import Button from "components/CustomButtons/Button.jsx";


const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        },
        icon:{
            margin: "8px 0px 8px 8px",
            position: "relative",
            top: "7px",
            paddingLeft: "8px",
        },
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Poppins', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    tableStyle: {
        padding: 0
    }
};

const SettingTableStructure = ({classes, currentPage, pageSize, handleApprove, records, filterUsers, filterServiceType, user, handleEdit, handleApproveThreshold, filterAirlines}) => (
    <Table className={classes.table} aria-labelledby="tableTitle">
        <TableHead className={classes.negativeColor} color="primary">
            <TableRow>
                <TableCell padding="none">S/N</TableCell>
                <TableCell padding="none">Old PSC Charge</TableCell>
                <TableCell padding="none">New PSC Charge</TableCell>
                <TableCell padding="none">Created By </TableCell>
                <TableCell padding="none">Currency</TableCell>
                <TableCell padding="none">Service Type</TableCell>
                <TableCell padding="none">Start Date</TableCell>
                <TableCell padding="none">Status </TableCell>
                <TableCell padding="none">Action</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {records && records.map((item, key) => {
                return (
                    <TableRow hover key={key}>
                        <TableCell padding="none" component="th">
                            {currentPage === 1 ? key + 1 : (pageSize * currentPage) + key + 1}
                        </TableCell>
                        <TableCell padding="none" component="th">
                            &#36; {appHelpers.numberWithCommas(item.OldCharges)}
                        </TableCell>
                        <TableCell padding="none" component="th">
                            &#36; {appHelpers.numberWithCommas(item.NewCharges)}
                        </TableCell>
                        <TableCell padding="none">
                            {item.CreatedBy ? filterUsers(item.CreatedBy) : "N/A"}
                        </TableCell>
                        <TableCell padding="none" component="th">{item.Currency}</TableCell>
                        <TableCell padding="none" component="th">{filterServiceType(item.ServiceType)}</TableCell>
                        <TableCell padding="none" component="th">{moment(item.StartDate).format("YYYY-MM-DD")}</TableCell>
                        <TableCell padding="none">
                            {
                                item.IsApproved === null &&
                                <span>
                                    Pending
                                </span>
                            }
                            {
                                item.IsApproved === 0 &&
                                <span>
                                    Declined
                                </span>
                            }
                            {
                                item.IsApproved === 1 &&
                                <span>
                                    Approved
                                </span>
                            }
                        </TableCell>
                        <TableCell padding="none">
                            {item.CreatedBy === user.userId ?
                                <span
                                    style={{cursor: "pointer", color: "#dd2735"}}
                                    onClick={() => handleEdit(item)}
                                >
                                    <span style={{
                                        margin: "8px 0px 8px 8px",
                                        position: "relative",
                                        top: "7px",
                                        paddingLeft: "8px",
                                    }}>
                                        <Edit/></span> Edit
                               </span>
                                : ""
                            }
                            {item.CreatedBy !== user.userId ?
                                <span>
                                  <span onClick={()=>handleApprove(0,item.Id)} style={{cursor: "pointer", color: "#dd2735"}}>
                                      <span style={{
                                          margin: "8px 0px 8px 8px",
                                          position: "relative",
                                          top: "7px",
                                          paddingLeft: "8px",
                                      }}><Decline/> </span>Decline
                  </span>
                                 <span onClick={()=>handleApprove(1,item.Id)}  style={{cursor: "pointer", color: "#66bb6a"}} autoFocus>
                                      <span style={{
                                          margin: "8px 0px 8px 8px",
                                          position: "relative",
                                          top: "7px",
                                          paddingLeft: "8px",
                                      }}><Approve /> </span>Approve
                  </span>
                                    </span>
                                : ""
                            }
                        </TableCell>
                    </TableRow>
                );
            })}
        </TableBody>
    </Table>
);

class AllPscTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            flight: false
        };
    }

    handleClickOpen = (flight) => {
        this.setState({ open: true });
        this.setState({flight});
        this.props.fetchFlightPassengers(flight.Id);
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    render() {
        const { classes, totalCounts, handleApprove, handleEdit, handleApproveThreshold, filterUsers,filterServiceType, fetchRecords, currentPage, pageSize, user, records, filterAirlines } = this.props;
        if(totalCounts === 0)
            return (<EmptyRecord message={'No pending airline PSC Charge yet!'}/>);
        return (
            <div>
                <div className={classes.tableResponsive} style={{ overflowX: "auto" }}>
                    <RecordPagination fetchMore={fetchRecords} totalCount={totalCounts} pageSize={pageSize} currentPage={currentPage} target={<SettingTableStructure currentPage={currentPage} pageSize={pageSize} handleApprove={handleApprove} records={records} classes={classes} filterUsers={filterUsers} filterServiceType={filterServiceType} handleEdit={handleEdit} handleApproveThreshold={handleApproveThreshold} user={user} filterAirlines={filterAirlines}/>}/>
                </div>
            </div>
        );
    }
}

export default withMobileDialog()(withStyles(styles)(AllPscTable));



// WEBPACK FOOTER //
// ./src/Regional-Views/PscSettings/allCharges.js